import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, Col, Row, Form, Button, CardBody, CardHeader } from 'reactstrap';
import { getAPI } from "../../Base/API";
import { ErrorAlert } from "../../Common/ErrorAlert";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';
import { CustomDateRangePicker } from '../../Base/Common/CustomReactDates';
import { handleNotification } from '../../Base/Notification';
import { CustomTable } from '../../Base/Common/CustomTable';
import { FormatAmountNumber } from '../../Base/Common/CommonUIComponents';
import { Pagination, ResultsPerPage, TotalResults } from '../../Base/Common/PaginationComponents';


class Shift4Events extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            totalCount: 0,
            events: [],
            totalCount: 0,
            limit: 10,
            startingAfter: null,
            endingBefore: null,
            page: 0,
        }
    }

    componentDidMount() {
        this.getEvents()
    }

    getEvents = (endingBefore, startingAfter) => {
        this.setState({ block: true });

        var params = `?startDate=${moment(this.props.startDate).format("YYYY-MM-DD")}&endDate=${moment(this.props.endDate).format("YYYY-MM-DD")}&limit=${this.state.limit}`;

        if (endingBefore) params += `&endingBefore=${endingBefore}`;
        else if (startingAfter) params += `&startingAfter=${startingAfter}`;

        getAPI(result => {
            const { data, error } = result;
            var errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }

                var events = data.response[0]?.list;
                var totalCount = data.response[0]?.totalCount;
                var hasMore = data.response[0]?.hasMore;
                var endingBefore = null;
                var startingAfter = null;

                if (events?.length > 0) {
                    var page = this.state.page; 
                    
                    if (page === 0 && totalCount > this.state.limit) startingAfter = events[events.length - 1]?.id;
                    if (page !== 0) {
                        if (hasMore ) {
                            startingAfter = events[events.length - 1]?.id;
                        }
                            
                        endingBefore = events[0]?.id;
                    }
                }
                

                this.setState({ 
                    events, totalCount,
                    hasMore, startingAfter, endingBefore, 
                    block: false, 
                    error: errorMessage 
                });
            }
            else {
                this.setState(({ block: false, error: errorMessage }));
            }
        }, `/api/Price/Shift4/v1/events` + params);
    }

    doSearch = (evt) => {
        evt.preventDefault();

        this.setState({ page: 0 }, () => this.getEvents());
    }

    handlePagination = (direction) => {
        const { endingBefore, startingAfter, page } = this.state;

        if (direction === -1 && endingBefore) {
            this.setState(
                { page: page - 1 },
                () => this.getEvents(endingBefore, null)
            );
        } else if (direction === 1 && startingAfter) {
            this.setState(
                { page: page + 1 },
                () => this.getEvents(null, startingAfter)
            );
        }
    }
        
    changePageSize = (evt) => {
        const { value } = evt.target;

        if (this.state.limit !== value) {
            this.setState({ limit: value, page: 0 }, _ => this.getEvents());
        }
    }


    render() {
        const { block, events, totalCount, limit, endingBefore, startingAfter, page } = this.state;

        const columns = [
            {
                dataField: 'type',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.Event" })
            },
            {
                dataField: 'data.amount',
                text: this.props.intl.formatMessage({ id: "generic.Amount" }),
                formatter: (cell, row) => cell ? <FormatAmountNumber value={cell / 100} currency={row.data.currency} /> : ''
            },
            {
                dataField: 'data.amountRefunded',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.AmountRefunded" }),
                formatter: (cell, row) => cell ? <FormatAmountNumber value={cell / 100} currency={row.data.currency} /> : ''
            },
            {
                dataField: 'data.email',
                text: this.props.intl.formatMessage({ id: "generic.Email" })
            },
            {
                dataField: 'id',
                text: "Id"
            },
            {
                dataField: 'created',
                text: this.props.intl.formatMessage({ id: "generic.Date" }),
                formatter: (cell) => moment.unix(cell).format("MM/DD/YYYY HH:mm:ss")
            }
        ]


        return (
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={this.state.error} />
                
                <Card className="border-0 shadow ">
                    <CardHeader className="bg-white border-bottom py-2">
                        <div><span className="far fa-calendar-alt mr-2"> </span> <FormattedMessage id="PaymentManagement.Events" /> </div>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={this.doSearch} className="mb-4">
                            <Row className="align-items-end">
                                <Col>
                                    <CustomDateRangePicker
                                        required
                                        startDate={this.props.startDate}
                                        startDateId="your_unique_start_date_id_events"
                                        isOutsideRange={day => day > moment()}
                                        endDate={this.props.endDate}
                                        endDateId="your_unique_end_date_id_events"
                                        onDatesChange={(startDate, endDate) => this.props.handleDates({ startDate, endDate })}
                                        numberOfMonths={1}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <Button className="btn btn-host btn-sm " type="submit">
                                        <i className="fa fa-search" />
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                        <Row>
                            <Col>
                                <CustomTable
                                    data={events || []}
                                    columns={columns}
                                    search={false}
                                    small={true}
                                    exportCSV={false}
                                    hideSizePerPage={true}
                                    sizePerPage={limit}
                                    hasPagination={false}
                                />
                            </Col>
                        </Row>
                        {totalCount > 0 ?
                            <div className="py-4 d-flex align-items-center">
                                <div className='w-50' style={{maxWidth: '50%'}}>
                                    <ResultsPerPage
                                        changeSizePerPage={this.changePageSize}
                                        pageSize={limit}
                                    />

                                    {!global.isMobile ?
                                        <span className="ml-2">
                                            <TotalResults
                                                end={page * limit + events.length}
                                                start={page * limit + 1}
                                                total={totalCount}
                                            />
                                        </span>
                                    :''}
                                </div>
                                <div className="w-50 d-flex justify-content-end" style={{maxWidth: '50%'}}>
                                    <Pagination
                                        isPrevDisabled={!endingBefore}
                                        isNextDisabled={!startingAfter}
                                        currentPage={page + 1}
                                        handlePrevButton={() => this.handlePagination(-1)}
                                        handleNextButton={() => this.handlePagination(1)}
                                    />
                                </div>
                            </div>
                        : ''}
                    </CardBody>
                </Card>
            </BlockUi>
        )
    }
}

export default injectIntl(Shift4Events);
